var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.889 9.333a.458.458 0 01-.315-.124L.13 4.967a.412.412 0 010-.6L4.574.123a.46.46 0 01.63 0 .412.412 0 010 .6L1.072 4.668l4.13 3.942a.412.412 0 010 .6.458.458 0 01-.314.124z",
    fill: "#000"
  })));
}
SvgBackArrow.displayName = 'BackArrow';
export default SvgBackArrow;